<template>
  <div
    class="sidebar-header row items-center no-wrap q-py-sm q-px-md"
  >
    <span class="text-subtitle1 text-weight-bold">Faces</span>
    <q-space />
    <q-btn
      size="sm"
      icon="fa fa-times"
      color="grey"
      flat round dense
      @click="$emit('close')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({ emits: ['close'] });
</script>

<style scoped>
.sidebar-header {
  border-bottom: 1px solid #e0e0e0;
  min-height: 48px;
  flex-shrink: 0;
}
</style>
